import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { Range } from "react-range";
// import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Products from "../components/products/Products";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import { HiStar } from "react-icons/hi2";
import { TbStarOff } from "react-icons/tb";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import {
  // price_range_product,
  query_products,
} from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import SEO from "../components/SEO";

const Rating = ({ onChange }) => {
  const [rating, setRating] = useState(0);

  const handleRatingChange = (value) => {
    setRating(value);
    onChange(value);
  };

  return (
    <div className="py-3 flex flex-col gap-2">
      <h2 className="text-2xl font-semibold mb-2 text-primary">Rating</h2>
      <div className="flex items-center gap-2">
        {[1, 2, 3, 4, 5].map((value) => (
          <motion.span
            key={value}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.8 }}
            className={`text-3xl cursor-pointer ${rating >= value ? "text-orange-500" : "text-secondary/50"}`}
            onClick={() => handleRatingChange(value)}
          >
            <HiStar />
          </motion.span>
        ))}
        <button
          onClick={() => handleRatingChange("")}
          className="group flex items-center justify-start w-10 h-10 bg-secondaryLight rounded-full cursor-pointer relative overflow-hidden transition-all duration-300 shadow-lg md-lg:hover:w-11 hover:w-32 hover:rounded-full active:translate-x-1 active:translate-y-1"
        >
          <div className="flex items-center text-white justify-center w-full transition-all duration-300 group-hover:justify-start group-hover:px-4 ">
            <TbStarOff />
          </div>
          <div className="absolute pl-1 right-0 md-lg:hidden transform translate-x-full opacity-0 text-white text-lg font-semibold transition-all duration-300 group-hover:translate-x-[-16px] group-hover:opacity-100">
            Clear
          </div>
        </button>
      </div>
    </div>
  );
};

const SearchProducts = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const searchValue = searchParams.get("value");
  const {
    products,
    totalProduct,
    latest_product,
    categorys,
    priceRange,
    parPage,
  } = useSelector((state) => state.home);

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [filter, setFilter] = useState(true);
  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRatingQ] = useState("");
  const [sortPrice, setSortPrice] = useState("");

  const queryCategoey = (e, value) => {
    if (e.target.checked) {
      setSearchParams({
        ...Object.fromEntries(searchParams.entries()),
        category: value,
      });
    } else {
      const newParams = Object.fromEntries(searchParams.entries());
      delete newParams.category;
      setSearchParams(newParams);
    }
  };
  useEffect(() => {
    setState({
      values: [priceRange.low, priceRange.high],
    });
  }, [priceRange]);

  useEffect(() => {
    const queryProductsParams = {
      low: state.values[0] || "",
      high: state.values[1] || "",
      category,
      rating,
      sortPrice,
      pageNumber,
      searchValue,
    };

    dispatch(query_products(queryProductsParams));
  }, [
    dispatch,
    state.values,
    category,
    rating,
    pageNumber,
    sortPrice,
    searchValue,
  ]);

  return (
    <div className="w-full">
      <SEO
        title="Search Products"
        description="Search and browse our wide range of products including electronics, fashion, home essentials, and more on Apna Plaza."
      />
      <Headers />
      {/* Page Header */}
      <div className="bg-card py-11 border-b border-primaryLighter">
        <div className="w-full">
          <div className="flex flex-col justify-center items-start container mx-auto">
            <div className="flex justify-center items-center gap-3 mb-1.5 text-sm font-medium text-secondary">
              <span className="hover:text-primary cursor-pointer transition-colors">
                Home
              </span>
              <span className="text-primary">/</span>
              <span className="text-primary">Search Products</span>
            </div>
            <h2 className="text-4xl font-medium text-primary mb-2">
              Search Results
            </h2>
            <p className=" text-base">Find the products you're looking for </p>
          </div>
        </div>
      </div>
      <section className="py-14 lg:py-10">
        <div className="w-[85%]  md:w-[90%%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className={`md:block hidden ${!filter ? "mb-6" : "mb-0"}`}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center rounded-[10px] w-full py-2 px-3 bg-secondary text-white"
            >
              Filter Product
            </button>
          </div>
          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${filter ? "md:h-0 md:overflow-hidden md:mb-6" : "md:h-auto md:overflow-auto md:mb-0"}`}
            >
              <h2 className="text-2xl font-semibold mb-2 text-primary">
                Category
              </h2>
              <div className="py-2">
                {categorys.map((c, i) => (
                  <div
                    className="flex justify-start items-center gap-2 py-1"
                    key={i}
                  >
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        value=""
                        className="sr-only peer"
                        checked={category === c.name ? true : false}
                        onChange={(e) => queryCategoey(e, c.name)}
                        type="checkbox"
                        id={c.name}
                      />
                      <div className='w-4 h-4 border-2 border-secondary rounded-full peer-checked:border-secondary peer-checked:bg-secondary peer-checked:after:content-[""] peer-checked:after:block peer-checked:after:w-2 peer-checked:after:h-2 peer-checked:after:bg-card peer-checked:after:rounded-full peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:transform peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2 transition-colors duration-200'></div>
                    </label>
                    <label
                      className="text-primary block cursor-pointer"
                      htmlFor={c.name}
                    >
                      {c.name}
                    </label>
                  </div>
                ))}
              </div>
              <div className="py-2 flex flex-col gap-5">
                <h2 className="text-2xl font-semibold mb-2 text-primary">
                  Price
                </h2>
                {priceRange.high > priceRange.low ? (
                  <Range
                    step={5}
                    min={priceRange.low}
                    max={priceRange.high}
                    values={state.values}
                    onChange={(values) => setState({ values })}
                    renderTrack={({ props, children }) => (
                      <div
                        {...props}
                        className="w-[80%] ml-3 h-[3px] bg-secondary rounded-full cursor-default"
                      >
                        {children}
                      </div>
                    )}
                    renderThumb={({ props }) => (
                      <div
                        className="w-[15px] h-[15px] bg-secondary rounded-full "
                        {...props}
                      />
                    )}
                  />
                ) : (
                  <div className="w-[80%] h-[3px] bg-secondary/20 rounded-full" />
                )}
                <div>
                  <span className="text-primary  ml-3 font-bold text-base">
                    Rs.{Math.floor(state.values[0])}
                    {priceRange.high > priceRange.low && (
                      <> - Rs.{Math.floor(state.values[1])}</>
                    )}
                  </span>
                </div>
              </div>
              <Rating onChange={setRatingQ} />
              <div className="py-5 px-1 flex flex-col gap-4 md:hidden">
                <Products title="Latest Products" products={latest_product} />
              </div>
            </div>
            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className="pl-8 md:pl-0">
                <div className="py-4 bg-card mb-10 px-3 rounded-2xl flex justify-between items-center border">
                  <h2 className="text-lg  font-semibold md-lg:mx-0 text-primary mx-5">
                    {totalProduct} Products
                  </h2>
                  <div className="flex justify-center items-center gap-5">
                    <div class="relative flex group rounded-[10px] overflow-hidden cursor-pointer">
                      <select
                        onChange={(e) => setSortPrice(e.target.value)}
                        class="appearance-none  relative text-primary bg-card ring-0 outline-none border border-secondary cursor-pointer text-sm font-normal rounded-xl block p-2.5"
                      >
                        <option value="">Sort By</option>
                        <option value="low-to-high">Low to High Price</option>
                        <option value="high-to-low">High to Low Price</option>
                      </select>
                      <svg
                        y="0"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        width="100"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="xMidYMid meet"
                        height="100"
                        class="w-8 h-8 absolute right-0 rotate-180 stroke-secondary top-1.5 group-hover:rotate-0 duration-300"
                      >
                        <path
                          stroke-width="4"
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          fill="none"
                          d="M60.7,53.6,50,64.3m0,0L39.3,53.6M50,64.3V35.7m0,46.4A32.1,32.1,0,1,1,82.1,50,32.1,32.1,0,0,1,50,82.1Z"
                          class="svg-stroke-primary"
                        ></path>
                      </svg>
                    </div>

                    <div className="flex justify-center items-start gap-4 md-lg:hidden">
                      <div
                        onClick={() => setStyles("grid")}
                        className={`p-2 ${styles === "grid" && "bg-secondary/20"} text-secondary  cursor-pointer rounded-lg`}
                      >
                        <BsFillGridFill />
                      </div>
                      <div
                        onClick={() => setStyles("list")}
                        className={`p-2 ${styles === "list" && "bg-secondary/20"} text-secondary cursor-pointer rounded-lg`}
                      >
                        <FaThList />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pb-8 ">
                  <ShopProducts products={products} styles={styles} />
                </div>
                <div>
                  {totalProduct > parPage && (
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SearchProducts;
